/**
 * ContextModel
 *
 * @module ContextModel
 */
(function ContextModel(){

    /**
     * Check if current context is in backend
     * @method isBackend
     */
    function isBackend() {
        return document.querySelectorAll('body')[0].classList.contains('neos-backend');
    }

    /**
     * Check if current context is in frontend
     * @method isFrontend
     */
    function isFrontend() {
        return !document.querySelectorAll('body')[0].classList.contains('neos-backend');
    }

    if(typeof window.TechDivisionMap === 'undefined') {
        window.TechDivisionMap = {};
    }
    window.TechDivisionMap.Context = {
        isBackend: isBackend,
        isFrontend: isFrontend
    };

})();